import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';

import styles from './styles.scss';

const navigateToConversation = conversationLinkHref => {
    window.location.assign(conversationLinkHref);
};

const CallInitiatedSuccess = props => {
    const { conversationLinkHref } = props;
    return (
        <div className={styles.prompt}>
            <FormattedMessage
                id="dc.buyerInitiateCall.messageSeller"
                defaultMessage="No answer? Message the seller to schedule another time to call."
            />
            <Button
                className={styles.button}
                dataTn="go-to-conversation-button"
                onClick={() => navigateToConversation(conversationLinkHref)}
                fullWidth
            >
                <FormattedMessage
                    id="dc.buyerInitiateCall.goToConversation"
                    defaultMessage="Go to Conversation"
                />
            </Button>
        </div>
    );
};

CallInitiatedSuccess.propTypes = {
    conversationLinkHref: PropTypes.string,
};
CallInitiatedSuccess.defaultProps = {
    conversationLinkHref: '/my/conversations/',
};

export default CallInitiatedSuccess;
